import { render, staticRenderFns } from "./FederationSeries.vue?vue&type=template&id=d2981396&"
import script from "./FederationSeries.vue?vue&type=script&lang=js&"
export * from "./FederationSeries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports